/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBookingFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeBooking, serializeBookingRequest, type Booking, type BookingRequest, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Booking/Book
 */
export interface BookRequestBuilder extends BaseRequestBuilder<BookRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Booking>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: BookingRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Booking | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: BookingRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BookRequestBuilderUriTemplate = "{+baseurl}/Booking/Book";
/**
 * Metadata for all the requests in the request builder.
 */
export const BookRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BookRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBookingFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBookingRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
